/* Mobile fixes — EverybodySnack (Oct 2026)
   #2 The mobile menu rendered the same links twice when the header's
   Secondary menu block uses the same menu as the main menu. Keep one copy
   of each link (preferring the version with an icon). */
(function () {
  function dedupeMenu() {
    document.querySelectorAll('.mobile-menu-drawer [data-category-content="menu"] .mobile-menu-list').forEach(function (list) {
      var seen = {};
      var items = Array.prototype.slice.call(list.children);
      // Pass 1: remember the icon versions
      items.forEach(function (li) {
        var a = li.querySelector(':scope > a.mobile-menu-link');
        if (a && li.classList.contains('has-secondary-menu-icons')) seen[a.getAttribute('href')] = li;
      });
      // Pass 2: hide plain duplicates, and later duplicates of anything
      var kept = {};
      items.forEach(function (li) {
        var a = li.querySelector(':scope > a.mobile-menu-link');
        if (!a) return;
        var href = a.getAttribute('href');
        var preferred = seen[href];
        if ((preferred && preferred !== li) || kept[href]) {
          li.hidden = true;
        } else {
          kept[href] = true;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dedupeMenu);
  } else {
    dedupeMenu();
  }
})();
